import React from "react";
import { Link } from "react-router-dom";

import "./404.css";

const NotFound = () => {
  return (
    <div className="not-found">
      <h1 className="error-code">404</h1>
      <p className="error-message">Halaman tidak ditemukan.</p>
      <Link to="/" className="home-link">Kembali ke Beranda</Link>
    </div>
  );
};

export default NotFound;
